import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Switch, Route, Redirect } from "react-router-dom";
import { Container } from "reactstrap";

import Category from "../components/Category/Category";
import ChannelList from "../components/ChannelList/ChannelList";
import ShowList from "../components/ShowList/ShowList";
import Account from "../components/Account/Account";
import Favorites from "../components/Favorites/Favorites";
import PlayChannel from "../components/Play/PlayChannel";
import PlayVideo from "../components/Play/PlayVideo";
import PlayOther from "../components/Play/PlayOther";
import SearchPage from "../components/SearchPage/SearchPage";
import SmartTV from "../components/SmartTV/SmartTV";
import SmartTVGuide from "../components/SmartTVGuide/SmartTVGuide";
import History from "../components/History/History";
import StaticPages from "../components/StaticPages/StaticPages";
import Domain from "../components/Domain/Domain";
import Country from "../components/Country/Country";
import AddCountryLanguage from "../components/Country/AddCountryLanguage";
import FlashMessage from "../components/FlashMessage/FlashMessage";
import SearchPageforES from "../components/SearchPage/SearchPageforES";
import { show, hide } from "../actions/ActivityIndicatorActions";
import { searchText } from "../actions/SearchActions";
import { console_log, getBidiotvMoviesListByLang } from "../utils/helper";
import { config } from "../constants/domainConfig";

class Home extends Component {
  constructor(props) {
    super(props);

    this.goToPage = this.goToPage.bind(this);
  }

  componentWillMount() {
    getBidiotvMoviesListByLang();
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {}

  goToPage(path) {
    if (this.props.location.pathname != path) {
      this.props.history.push(path);
    }
  }

  render() {
    let uid = this.props.access.uid;
    if (this.props.search.searchText != "") {
      return (
        <SearchPage
          goToPage={this.goToPage}
          path={this.props.location.pathname}
        />
      );
    } else {
      return (
        <main className="home main subscript-box main-height">
          <FlashMessage path={this.props.location.pathname} />
          <Container>
            <Switch>
              <Route path="/domain" name="Domain" component={Domain} />
              <Route path="/country" name="Country" component={Country} />
              <Route
                path="/manage-country"
                name="Country Language"
                component={AddCountryLanguage}
              />
            </Switch>
          </Container>
          <Switch>
            <Route path="/home" name="CategoryPage" component={Category} />
            <Route
              path="/search"
              name="SearchPageForEs"
              component={SearchPageforES}
            />
            <Route
              path="/channels/:id"
              name="ChannelList"
              component={ChannelList}
            />
            <Route path="/movies/:id" name="ShowList" component={ShowList} />
            <Route
              path="/videos/:id"
              name="VideoList"
              component={ChannelList}
            />
            <Route path="/account" name="Account" component={Account} />
            <Route path="/favorites" name="Favorites" component={Favorites} />
            <Route
              path="/play/channel"
              name="Play Channel"
              component={PlayChannel}
            />
            <Route
              path="/play/video"
              name="Play Channel"
              component={PlayVideo}
            />
            <Route path="/show" name="Play" component={PlayOther} />
            <Route path="/smartTv" name="SmartTV" component={SmartTV} />
            <Route
              path="/all/:id"
              name="SmartTVGuide"
              component={SmartTVGuide}
            />
            <Route path="/history" name="History" component={History} />
            <Route path="/about" name="About" component={StaticPages} />
            <Route
              path="/privacy-policy"
              name="PrivacyPolicy"
              component={StaticPages}
            />
            <Route
              path="/terms-conditions"
              name="TermsConditions"
              component={StaticPages}
            />
            {/* <Route path='*' component={Login}/> */}
          </Switch>
        </main>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    access: state.WelcomeReducer,
    account: state.AccountReducer,
    category: state.CategoryReducer,
    country: state.CountryReducer,
    domain: state.DomainReducer,
    favorite: state.FavoriteReducer,
    flashmessage: state.FlashMessageReducer,
    historyVideos: state.HistoryReducer,
    loader: state.ActivityIndicatorReducer,
    play: state.PlayReducer,
    search: state.SearchReducer,
    smartTV: state.SmartTVReducer,
    splash: state.SplashScreenReducer,
    user: state.AuthenticationReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      show,
      hide,
      searchText,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.js